import { cva } from "class-variance-authority";

export const autoCompleteStyles = {
  container: cva("flex max-w-[400px] flex-col", {
    variants: {
      size: {
        medium: "gap-1.5",
        small: "gap-1",
      },
    },
    defaultVariants: {
      size: "medium",
    },
  }),
  label: cva("font-medium text-gray-900", {
    variants: {
      size: {
        medium: "text-base",
        small: "text-sm",
      },
    },
    defaultVariants: {
      size: "medium",
    },
  }),
  input: cva(
    "w-full rounded-md border border-gray-300 py-2 text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 placeholder:font-normal placeholder:text-gray-400",
    {
      variants: {
        size: {
          medium: "h-11 px-3.5 py-2.5 text-base placeholder:text-base",
          small: "h-9 px-3 py-2 text-sm placeholder:text-sm",
        },
      },
      defaultVariants: {
        size: "medium",
      },
    },
  ),
  options: cva(
    "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
    {
      variants: {
        size: {
          medium: "text-base",
          small: "text-sm",
        },
      },
      defaultVariants: {
        size: "medium",
      },
    },
  ),
};
